<script>
import appConfig from '@src/app.config.json'
import Axios from '@plugin/axios'
import Layout from '@layouts/main.vue'
import Hero from '@components/ui/hero-jumbotron.vue'
import NewsCard from '@components/ui/cards/news-card.vue'
import Pagination from '@components/ui/basic-pagination.vue'

export default {
  page() {
    return {
      title: this.pageTitle,
      meta: this.pageMeta,
    }
  },
  components: {
    Layout,
    Hero,
    NewsCard,
    Pagination,
  },
  filters: {
    capitalize: function(value) {
      if (!value) return ''
      const penghubung =
        'and,for,with,of,dan,serta,atau,tetapi,melainkan,padahal,sedangkan,yang,agar,supaya,biar,jika,kalau,jikalau,asalkan,bila,manakala,sejak,semenjak,sedari,sewaktu,tatkala,ketika,sementara,begitu,seraya,selagi,selama,serta,sambil,demi,setelah,sesudah,sebelumsehabis,selesai,seusai,hingga,sampai,andaikan,seandainya,umpamanya,sekiranya,biarpun,walaupun,sekalipun,sungguhpun,kendatipun,seakan-akan,seolah-olah,sebagaimana,seperti,sebagai,laksana,ibarat,daripada,alih-alih,karena,sampainya,makanya,dengan,tanpa,bahwa,as,ke'
      const str = value
        .trim()
        .replace(/ {1,}/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word) => {
          if (penghubung.split(',').includes(word)) {
            return word[0].toLowerCase() + word.slice(1)
          } else if (word[0] === '(') {
            return '(' + word.charAt(1).toUpperCase() + word.substring(2)
          }
          return word[0].toUpperCase() + word.slice(1)
        })
        .join(' ')
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    excerpt: function(text, limit) {
      return (
        text
          .split(/\s+/)
          .slice(0, limit)
          .join(' ') + '...'
      )
    },
  },
  data() {
    return {
      News: [],
      page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      limit: 10,
      isLoading: true,
      pageName:
        window.location.pathname.split('/').filter((val) => val)[0] ===
        undefined
          ? window.location.pathname.split('/').filter((val) => val)[0]
          : 'default',
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
      activeOrder: '',
      /** for SEO, meta and hero */
      pageTitle: 'Loading...',
      pageDescription: '',
      /** end seo */
      params: [],
      generatedParams: '',
    }
  },
  watch: {
    page: function() {
      this.loadOpacity = true
      if (this.page >= 1) {
        this.params.page = this.page
        return new Promise((resolve, reject) => {
          resolve(this.getNews(this.params))
        })
      }
    },
  },
  async mounted() {
    await this.getNews()
    // this.activeOrder = $t('Latest')
  },
  methods: {
    getNews: function(param = {}) {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'news',
        simple: true,
        page: this.page,
        lang: this.lang,
        limit: this.limit,
        order: 'DESC',
        order_by: 'created_at',
        taxonomy_show: false,
      }
      this.params = params
      /** params need to encoded from object to url params */
      params = this.generateParams(params, param)
      this.generatedParams = params
      /** define endpoint */
      var endpoint = `klaster-by-member-relation?${params}`
      // get the news
      Axios.get(endpoint).then((response) => {
        const data = response.data.data
        // after successfull response, we should then update the menuItems on data() above
        if (response.data) {
          this.News = data
          this.totalPages = response.data.page_total
          this.totalData = response.data.data_total
          this.isLoading = false
        }
        /** FOR SEO and META tag */
        let keyInfo
        if (response.data.info[this.lang] !== undefined) {
          keyInfo = response.data.info[this.lang]
        } else {
          keyInfo = response.data.info[this.lang + ' ']
        }
        this.pageTitle = keyInfo[0].trim()
        this.pageDescription = keyInfo[1].trim()
        this.pageMeta = [
          {
            name: 'description',
            content: keyInfo[1].trim(),
          },
          // facebook
          {
            property: 'og:type',
            content: 'article',
          },
          {
            property: 'og:title',
            content: keyInfo[0].trim(),
          },
          {
            property: 'og:description',
            content: keyInfo[1].trim(),
          },
          {
            property: 'og:url',
            content: this.currentUrl,
          },
          {
            property: 'og:site_name',
            content: appConfig.title,
          },
          // twitter
          {
            name: 'twitter:title',
            content: keyInfo[0].trim(),
          },
          {
            name: 'twitter:description',
            content: keyInfo[1].trim(),
          },
          {
            name: 'twitter:site',
            content: this.currentUrl,
          },
        ]
      })
    },
    /**
     * Ordering Function
     */
    order: function(order, orderBy, active = '') {
      // this.News = this.News
      this.activeOrder = active
      this.getNews({
        order: order,
        order_by: orderBy,
      })
    },
    s3: function(path) {
      return appConfig.s3_endpoint + path
    },
    /**
     * Handler paginate
     */
    pageHandler: function(to) {
      this.page = to
      this.scrollToTargetAdjusted('news-handler')
    },
    plainText: function(HTML) {
      var input = HTML
      return input
        .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
        .replace(/<[^>]+?>/g, '')
        .replace(/\s+/g, ' ')
        .replace(/ /g, ' ')
        .replace(/>/g, ' ')
    },
    excerpt: function(text, limit) {
      return (
        text
          .split(/\s+/)
          .slice(0, limit)
          .join(' ') + '...'
      )
    },
  },
}
</script>

<template>
  <Layout>
    <Hero
      height="25rem"
      :background="require('@assets/images/demo/news/banner.jpg')"
    >
      <b-container class="h-100">
        <b-row class="justify-content-center h-100">
          <div class="col-lg-12 text-center align-self-center">
            <h1
              class="text-white"
              :style="{ fontSize: '2.75rem', fontWeight: '700' }"
              >{{ pageTitle }}</h1
            >
            <p
              class="mt-3 mb-4"
              :style="{
                color: '#fff',
                fontSize: '1.2rem',
                fontWeight: '300',
              }"
              >{{ pageDescription }}</p
            >
          </div>
        </b-row>
      </b-container>
    </Hero>

    <b-container id="news-handler" class="my-5">
      <b-row class="mt-5 justify-content-end">
        <b-col cols="lg-3 text-right mt-5">
          <span class="mr-3" :style="{ color: 'gray' }">{{
            $t('Sort by')
          }}</span>
          <b-dropdown
            :text="$t(activeOrder ? activeOrder : 'Latest')"
            variant="light"
            class="mx-0"
            :class="$style.newsFilter"
          >
            <b-dropdown-item
              @click="order('desc', 'created_at', $t('Latest'))"
              >{{ $t('Latest') }}</b-dropdown-item
            >
            <b-dropdown-item
              @click="order('asc', 'created_at', $t('Oldest'))"
              >{{ $t('Oldest') }}</b-dropdown-item
            >
          </b-dropdown>
        </b-col>
      </b-row>
      <!-- NEWS SECTION -->
      <div
        v-show="isLoading"
        class="position-relative"
        style="min-height: 5rem"
      >
        <img
          src="@assets/icons/loading.gif"
          alt="loading"
          class="loadingIcon"
        />
      </div>
      <b-row v-if="!isLoading">
        <div
          v-for="(item, index) in News"
          :key="index"
          style="display: contents"
        >
          <b-col cols="lg-6" class="d-flex align-items-scretch">
            <NewsCard
              :title="item.title"
              :content="
                item.atribut.caption.data.length !== 0 &&
                item.atribut.caption.data[0].content
                  ? plainText(item.atribut.caption.data[0].content)
                  : plainText(excerpt(item.content, 40))
              "
              :date="item.created_at_format"
              :img-src="
                item.atribut.length !== 0 &&
                item.atribut.featured_image.data.length !== 0
                  ? s3(item.atribut.featured_image.data[0].content)
                  : ''
              "
              class="w-100"
              :url="'/news/' + item.slug"
              :border="true"
            >
            </NewsCard>
          </b-col>
        </div>
        <span v-if="News.length === 0 && isLoading === false">
          {{ $t('No data') }}
        </span>
        <div class="col-12">
          <Pagination
            v-if="totalData > limit"
            :total-pages="totalPages"
            :selected-page="page"
            :params="generatedParams"
            :limit="limit"
            class="my-5"
            @clicked="pageHandler"
          ></Pagination>
        </div>
      </b-row>
    </b-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.newsFilter {
  ul[role='menu'] {
    &:focus {
      outline: none;
    }
  }
  button {
    background-color: $white;
    border: 1px solid $gray;
    border-radius: 0;
  }
}
</style>
